(function () {

    angular
        .module('smartertoolsApp')
        .controller('licenseKeyController', ['$scope', '$timeout', 'licenseKeyService', 'notificationFactory', licenseKeyController]);

    function licenseKeyController($scope, $timeout, licenses, notify) {
        var vm = this;
        vm.dateOnServer = Date.now();
        vm.paging = {page: 1, itemsPerPage: 10};
        vm.search = '';
        vm.selectedLicenseKey = null;
        vm.totalFilteredItems = 0;

        // Functions
        vm.filter = filter;
        vm.getCsvData = getCsvData;
        vm.getCsvHeader = getCsvHeader;
        vm.getPurchaseLink = getPurchaseLink;
        vm.isExpired = isExpired;
        vm.isExpiringSoon = isExpiringSoon;
        vm.isExpiringVerySoon = isExpiringVerySoon;
        vm.modalShowPage = modalShowPage;
        vm.refresh = refresh;
        vm.resetActivations = resetActivations;
        vm.showDetailsModal = showDetailsModal;
        vm.sort = sort;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refresh();
            $scope.$on('cache-clear', (event, data) => {
                refresh();
            });
        }

        function filter() {
            $timeout(function () {
                vm.totalFilteredItems = vm.filteredLicenseKeys ? vm.filteredLicenseKeys.length : 0;
            }, 10);
        }

        function getCsvData() {
            var newArr = [];
            for (let i = 0; i < vm.licenseKeys.length; i++) {
                const lk = vm.licenseKeys[i];
                let addonNames = '';
                for (let j = 0; j < lk.Addons.length; j++) {
                    const a = lk.Addons[j];
                    if (addonNames != '')
                        addonNames += ', ';
                    addonNames += a.DisplayName;
                }

                newArr.push({
                    lk: lk.LicenseKey,
                    product: lk.Product,
                    addons: addonNames,
                    up: lk.UpgradeProtectionExpiresUtc ? moment(lk.UpgradeProtectionExpiresUtc).format() : '',
                    server: lk.Server,
                    lastActivatedIpAddress: lk.LastActivatedIpAddress,
                });
            }
            return newArr;
        }

        function getCsvHeader() {
            return ['License Key', 'Product', 'Addons', 'Maintenance Expires', 'Server', 'Last Activated IP'];
        }

        function getPurchaseLink(lk) {
            if (lk == null || lk.Product == null)
                return '/purchase/select-product';
            const product = lk.Product;
            if (/^smartermail/i.test(product))
                return '/purchase/#/add/smartermail';
            if (/^smarterstats/i.test(product))
                return '/purchase/#/add/smarterstats';
            if (/^smartertrack/i.test(product))
                return '/purchase/#/add/smartertrack';
            return '/purchase/select-product';
        }

        function isExpired(expires) {
            return new Date(expires) < Date.now();
        }

        function isExpiringSoon(expires) {
            let soon = new Date();
            soon.setDate(soon.getDate() + 60);
            return !vm.isExpired(expires) && (new Date(expires) < soon);
        }

        function isExpiringVerySoon(expires) {
            let soon = new Date();
            soon.setDate(soon.getDate() + 15);
            return !vm.isExpired(expires) && (new Date(expires) < soon);
        }

        function modalShowPage(page) {
            vm.modalPage = page;
        }

        function refresh() {
            $scope.accountCtrl.isLoading++;
            licenses.getLicenses()
                .then((data) => {
                    $scope.accountCtrl.isLoading--;
                    vm.trialLicenseKeys = data.Trials;
                    vm.licenseKeys = data.Licenses;
                    vm.filter();
                })
                .catch((err) => {
                    $scope.accountCtrl.isLoading--;
                });
        }

        function resetActivations() {
            if (vm.resetActivationModal.$invalid)
                return;

            var reason = vm.licenseKeyResetReason;
            if (reason == 'Other')
                reason = vm.licenseKeyResetReasonOther;
            if (!reason) {
                notify.error('A reason is required');
                return;
            }
            vm.isSending = true;
            licenses.resetActivations(vm.selectedLicenseKey.LicenseKey, reason)
                .then(() => {
                    vm.isSending = false;
                    vm.selectedLicenseKey.ActivationsLeft = 2;
                    vm.modalShowPage('reset-activations-done');
                })
                .catch(() => {
                    vm.isSending = false;
                    notify.error('There was a problem resetting activations.  Please contact our sales team.');
                });
        }

        function showDetailsModal(item, startPage) {
            startPage = startPage || 'start';
            vm.selectedLicenseKey = item;
            vm.modalPage = startPage;
            vm.licenseKeyResetReason = '';
            vm.licenseKeyResetReasonOther = '';
            vm.isSending = false;
            vm.resetActivationModal.$setPristine();
            vm.resetActivationModal.$setUntouched();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('licensekey-details-modal')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function sort(keyName) {
            vm.reverse = vm.sortKey !== keyName || !vm.reverse;
            vm.sortKey = keyName;
        }
    }

})();